<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-if="icard_common_data != null">
      <div v-for="(inst_data, ind) in icard_data" :key="ind">
        <div class="cardbody1">
          <div class="frontside">
            <div>
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <img
                    class="logo"
                    style="margin-top: -4px"
                    :src="icard_common_data.logo"
                    height="90"
                    width="100%"
                    alt="logo"
                  />
                </v-col>
              </v-row>

              <div>
                <center class="school-name">
                  <span class="schlname" v-html="icard_common_data.school_name">
                  </span
                  ><br />
                  <span class="schladdr">{{
                    icard_common_data.school_address
                  }}</span
                  ><br />
                </center>
              </div>

              <div class="empimg">
                <v-img
                  style="background-color: white"
                  height="220px"
                  :src="icard_common_data.watermark"
                >
                  <center>
                    <img
                      :src="inst_data.profile_photo_path"
                      class="box1"
                    />
                  </center>

                  <center style="font-size: 0.7em">
                    <div class="text-center">
                      <h2 style="color: white">{{ inst_data.name }}</h2>
                    </div>
                    <div class="text-center">
                      <h2 style="color: white">{{ inst_data.designation }}</h2>
                      <h2 style="color: white">
                        ZPRN:&nbsp;{{ inst_data.emp_code }}
                      </h2>
                    </div>
                  </center>
                </v-img>
                <center>
                  <barcode
                    height="50"
                    width="1"
                    :value="inst_data.emp_code"
                    displayValue="false"
                  >
                    Show this if the rendering fails.
                  </barcode>
                </center>
              </div>
            </div>
          </div>
        </div>
        <br />

        <div class="watermark_back">
          <div class="backside">
            <div>
              <v-img :src="icard_common_data.watermark_back"></v-img>
              <v-row justify="center">
                <v-col cols="12" sm="12" md="12">
                  <div class="ml-3" style="font-size: 0.8em">
                    <strong>Address : </strong>{{ inst_data.emp_address }}
                    <br />
                    <strong> Phone : </strong> {{ inst_data.emp_contact }}<br />
                    <strong> Emergency Contact: </strong>
                    {{ inst_data.emp_emergency_contact }}<br />
                    <strong>D.O.B.: </strong> {{ inst_data.emp_dob }}<br />
                    <strong>Blood Group: </strong>{{ inst_data.emp_blood_group
                    }}<br />
                    <strong>Joining Date: </strong>{{ inst_data.emp_doj }}<br />
                  </div>
                </v-col>
              </v-row>
              <strong class="ml-3" style="font-size: 1em">Rules:-</strong>

              <v-row
                dense
                v-for="(i, index) in icard_common_data.instruction"
                :key="index"
              >
                <ul class="inst">
                  <li style="padding-left: 0.3em">{{ i.topic }}</li>
                </ul>
              </v-row>
              <div>
                <v-row>
                  <v-col cols="12" sm="6" md="6"> </v-col>
                  <v-col cols="12" sm="6" md="6" align="right">
                    <img
                      :src="icard_common_data.sign"
                      class="sign"
                      alt="logo"
                    /><br />
                    <strong class="authority">{{ authority }}</strong>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
// import VueBarcode from "vue-barcode";
import VueBarcode from "vue-barcode";

import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  components: {
    // barcode: VueBarcode,
    barcode: VueBarcode,
  },
  data: () => ({
    comp_load: false,
    inst_list: null,
    radios: null,
    inst_data: null,
    icard_data: [],
    barcodeValue: "",
    authority: "Principal",
    authority_sign: null,
    icard_common_data: null,
    overlay: false,
  }),
  updated: function () {
    //console.log("Inside updated");
    // this.$nextTick().then(() => {
    //   if (this.icard_data != "") {
    //     // this.barcoded();
    //   }
    // });
  },
  mounted() {
    this.icardGenerate();
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    icardGenerate() {
      const data = {
        inst_data: this.inst_data,
      };
      this.overlay = true;
      axios
        .post("/Icard/icardBulkGenerate", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.icard_common_data = res.data.icard_common_data;
          } else {
            alert(res.data.snackbar);
          }
          // this.barcoded();
          this.overlay = false;
        })

        .catch((error) => {
          console.log("Error", error);
          alert("Somthing went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
  },
};
</script>

<style scoped>
.box1 {
  width: 38%; 
  height: 132px; 
  margin-top: 10px
}
.boxnew {
  background-color: white;
  width: 300.52755905896px;
  height: 204.01889764021797px;
  padding-left: 3px !important;
  padding-right: 2px !important;
  background-repeat: no-repeat !important;
}
.cardbody {
  width: 300px;
  display: inline-block;
  border-radius: 5px;
  padding: 5px;
  height: 480px;
  padding-top: 15px;
}

.cardbody1 {
  width: 300px;
  display: inline-block;
  border-radius: 5px;
  padding: 5px;
  height: 480px;
  /* padding-top: 15px; */
}

.schlname {
  color: #023a9c;
  font-size: large;
  font-weight: bold;
}

.schladdr {
  font-weight: bold;
}

.schlphone {
  font-weight: bold;
}

.signature {
  width: 38%;
  height: 60px;
  margin-bottom: 13px;
  margin-right: -70px;
}
* {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.barcode2 {
  margin-top: 5px;
  height: 10px;

  width: 10%;
}

.sign{
  width: 45%; 
  height: 45px; 
  margin-top: -6px
}

.authority{
  margin-right: 27px;
}

.watermark_back{
  margin-top: -12px; 
  padding-top: 15px;
}

.school-name{
 margin-top: -6px; 
 font-size: 0.7em;
}

.frontside{
 width: 18rem;
}

.backside{
 width: 18rem;
}
@media print {
  /* .pagebreak {
    
    page-break-before: always !important;
  }

  #noprint {
    display: none !important;
  } */
  @page {
    /* margin: -0.2645833mm; */
    margin: -0.18mm;
    /* margin-top: 0; */
    size: 53mm 85.6mm;
  }

  .logo {
    height: 80%;
  }

  .sign{
    width: 45%; 
    height: 45px; 
    margin-top: -6px
  }


.barcode2 {
  margin-top: 5px;
  height: 10px;

  width: 10%;
}


}
ul.inst {
  list-style-type: "*";
  font-weight: 500;

  font-size: 12px;

  text-align: left;
}
</style>